// the title of the workbench (shows up in the <title> and nav bar)
export const APP_TITLE = "Zoning.ml";
// the "blocking_task" type for this workbench
export const TASK_KIND = "zoning";

export const META_ROLE = "zoning-pagesmeta-json";
export const ZONES_IN_ROLE = "zoning-predicted-json";
export const ZONES_OUT_ROLE = "zoning-reviewed-json";
export const LO_RES_IMAGE_ROLE = "zoning-page-png";
export const HI_RES_IMAGE_ROLE = "zoning-pagehr-png";
